import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { AlertTriangle } from 'lucide-react';

export function DeleteConfirmDialog({ entry, type, open, onClose, onConfirm, isDeleting }) {
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-destructive">
            <AlertTriangle className="w-5 h-5" />
            Delete {type === 'waitlist' ? 'Waitlist Entry' : 'Pilot Application'}
          </DialogTitle>
          <DialogDescription>
            Are you sure you want to delete this entry?
          </DialogDescription>
        </DialogHeader>
        <div className="py-4">
          <div className="bg-muted/50 p-4 rounded-md space-y-2 text-sm">
            <div><span className="font-medium">Email:</span> {entry?.email}</div>
            {type === 'waitlist' && entry?.name && (
              <div><span className="font-medium">Name:</span> {entry.name}</div>
            )}
            {type === 'pilot' && (
              <>
                <div><span className="font-medium">Club:</span> {entry?.club_name}</div>
                <div><span className="font-medium">Contact:</span> {entry?.contact_name}</div>
              </>
            )}
          </div>
          <p className="text-sm text-destructive mt-4">This action cannot be undone.</p>
        </div>
        <DialogFooter>
          <Button type="button" variant="outline" onClick={onClose} disabled={isDeleting}>
            Cancel
          </Button>
          <Button type="button" variant="destructive" onClick={onConfirm} disabled={isDeleting}>
            {isDeleting ? 'Deleting...' : 'Delete Entry'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}